import moment from "moment";

export const buildConsumoSeries = (stats) => {
  const daily = (stats && stats.total_consumed_budget_by_day) || {};
  const dates = Object.keys(daily).sort();
  if (dates.length === 0) return null;

  const today = moment().startOf("day");
  let cumulative = 0;
  let lastPastIndex = -1;

  const points = dates.map((d, i) => {
    const value = Number(daily[d]) || 0;
    cumulative += value;
    const isPast = moment(d).startOf("day").isSameOrBefore(today);
    if (isPast) lastPastIndex = i;
    return {
      date: d,
      label: moment(d).format("DD/MM"),
      value,
      cumulative,
      isPast,
    };
  });

  return { points, lastPastIndex, total: cumulative };
};
